module.exports = __webpack_public_path__ + "img/cases-brand-herborist-9.8353207b.jpg";